import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../useAuth';

const DISMISS_KEY = 'cec_trial_banner_dismissed_session';

const TrialBanner: React.FC = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(DISMISS_KEY) === 'true');

  const sub = (user as any)?.subscription;
  if (!user || dismissed || sub?.status !== 'trialing' || !sub?.trialEndsAt) return null;

  const daysLeft = Math.max(0, Math.ceil((new Date(sub.trialEndsAt).getTime() - Date.now()) / (24 * 60 * 60 * 1000)));

  const dismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, 'true');
    setDismissed(true);
  };

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: 'var(--color-primary)',
        borderBottom: '1px solid var(--color-accent)',
        padding: '0.55rem 1.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        zIndex: 998,
      }}
    >
      <i className="bi bi-stars" style={{ color: '#f59e0b', fontSize: '1rem', flexShrink: 0 }} />

      <div style={{ flex: 1, fontFamily: 'var(--font-body)', fontSize: 'var(--fs-sm)' }}>
        <strong style={{ color: '#fff', marginRight: '0.5rem' }}>
          {daysLeft <= 1 ? 'Your Pro trial ends tomorrow' : `Pro Trial — ${daysLeft} days left`}
        </strong>
        <span style={{ color: 'rgba(255,255,255,0.75)' }}>
          Track multiple states and licenses free until then.
        </span>
        <Link to="/billing" style={{ color: '#f59e0b', fontWeight: 600, marginLeft: '0.75rem', textDecoration: 'none' }}>
          Manage Trial →
        </Link>
      </div>

      <button
        onClick={dismiss}
        aria-label="Dismiss trial notice"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'rgba(255,255,255,0.75)',
          padding: '0.25rem 0.375rem',
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          borderRadius: 'var(--radius-sm)',
        }}
      >
        <i className="bi bi-x-lg" style={{ fontSize: '0.875rem' }} />
      </button>
    </div>
  );
};

export default TrialBanner;
